export const GRUPOS_APPS = {
    GROUP_HERRALM: 'HERRALM_ALMACEN',
    GROUP_HILTISUPOP: 'HILTISUPOP'
}